import { AddIcon,SearchIcon, ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Stack, Text } from "@chakra-ui/layout";
import { Input, Button ,Divider, IconButton,Tabs, TabList, TabPanels, Tab, TabPanel, Tooltip } from '@chakra-ui/react'
import { useToast } from "@chakra-ui/toast";
import UserListItem from "./userAvatar/UserListItem";
import { Spinner } from "@chakra-ui/spinner";

// import { Divider } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { getSender } from "../config/ChatLogistics"
import ChatLoading from "./ChatLoading";
import GroupChatModal from "./misc/GroupChatModal";
import { ChatState } from "../context/chatProvider"
import  EnvRoute   from '../middleware/envRoute';
// import  useOnScreen  from '../hooks/useOnScreen';
// import  useIntersection  from '../hooks/useIntersection';
import { useHistory } from 'react-router-dom'
import UserChats from "./UserChats";
import GroupChats from "./GroupChats";
import { useDisclosure } from '@chakra-ui/react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/modal";
import SearchDrawer from "./SearchDrawer";

const ENDPOINT = EnvRoute('prod'); 

const checkIfGroup=(chat)=>{
        return chat.isGroupChat
    }
  const checkIfNotGroup=(chat)=>{
      return !chat.isGroupChat
  }

const MyChats = ({ fetchAgain }) => {

  const history = useHistory()
 const { isOpen, onOpen, onClose } = useDisclosure();
 const [ search, setSearch ] = useState("")
 const [ searchResult, setSearchResult ] = useState([])
 const [ loading, setLoading ] = useState(false)
 const [ loadingChat, setLoadingChat ] = useState()

  const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();
  const [loggedUser, setLoggedUser] = useState();
  const [tabIndex, setTabIndex] = useState(0)

   const toast = useToast();



   const fetchChats = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        body:{
         user:{
           _id:user?._id
         } 
        }
      };
      const data  = await axios.get(`${ENDPOINT}/api/chat/`, config)
      console.log("data.data: ", data)
      setChats([...data.data]);
      console.log("chats: ",typeof chats)
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the chats",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
    
  };
  const toggleScroll = (key) =>{
    console.log('scrolling text onhover test')
  }
  useEffect(() => {
      setLoggedUser(JSON.parse(localStorage.getItem("userInfo")));
      fetchChats();
      // console.log('tabIndes:', setTabIndex)
  }, 
  []);
let g_chats = chats.filter(checkIfGroup)
let u_chats = chats.filter(checkIfNotGroup)

  return (
    <Box
      display={{ base: selectedChat ? "none" : "flex", md: "flex" }}
      flexDir="column"
      alignItems="center"
      p={3}
      bg="white"
      w={{ base: "100%", md: "30%" }}
      minW={'250px'}
      borderRadius="0 10px 10px 10px"
      borderWidth="1px"
      boxShadow={"bxshd.inset_blk"}
      overflow={"scroll"}
      backgroundSize={"cover"}
      color={"txt.hdrLt"}
      // backdropFilter="auto"
      // backdropBlur={"5px"}
      // css={{backdropFilter: "blur(4px)"}}
       
    >
      
      <Box
        pb={3}
        px={3}
        // fontSize={{ base: "28px", md: "30px" }}
        fontSize={{ base: "32px", sm: "18px", md: "18px", lg: "25px" }}
        fontFamily="Gilroy"
        display="flex"
        flexDirection={"row"}
        w="100%"
        justifyContent="space-evenly"
        alignItems="center"
        borderRadius="10px 10px 0 0"
        color={'txt.hdrDrk'}
        
        // boxShadow={"bxshd.mainComp"}
        whiteSpace={'nowrap'}
      >
        {/* <Text>  */}
          Chat Feed
         {/* </Text> */}
    {(tabIndex ===0 )&&(
        <SearchDrawer /> 
    )}


       {(tabIndex === 1) &&(
       <GroupChatModal chats={chats}>
         <Tooltip 
            label="Create new group chat" 
            hasArrow 
            placement='bottom-end'>
          <Button
            display="flex"
            m={'5px 5px'}
            h={'25px'}
            variant="ghost" 
            color={'txt.hdrDrk'}
            colorScheme='blue'
            border={'1px solid #868686'}
             px={1}
             py={1}
            minW={'50px'}
            padding={'0.5rem'}
            borderRadius={'5px 5px 0px 0px'}
           fontSize={{ base: "16px", sm: "16px", md: "16px", lg: "16px" }}

            leftIcon={<AddIcon alignSelf={'center'} fontSize={'0.75rem'}/>}
            // boxShadow={"bxshd.chtBtn"}
            borderBottom={'none'}
          >
            {/* <Text  display={{base:"none", md: "flex"}} > */}
            <Text display={{base:"none", sm: "flex", md: "flex", lg: "flex"}} >

            Group Chat
            </Text>
          </Button>
          </Tooltip>
        </GroupChatModal>
      )} 
      </Box>

    <Divider mb={2} w={'70%'}/>
        
    <Tabs 
      variant='enclosed' 
      w="100%"
      h="100%" 
      color="#868686"
      defaultIndex={0}
      isManual 
      onChange={(index) => setTabIndex(index)}
      >
  <TabList h='25px' >
    <Tab>users ({u_chats.length})</Tab>
    <Tab>groups ({g_chats.length})</Tab>
  </TabList>

  <TabPanels >
    <TabPanel
    maxH={'90%'}
    // border={'1px solid blue'}
    >
       <Stack 
              minW={'200px'}
              minH={'400px'}
              // maxH={'80%'}
              h={'100%'}
              w={'100%'}
          >
       <Box
        display="flex"
        flexDir="column"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        // bg="#F8F8F8"  
        w="100%"
        h="100%"
        minH={"500px"}
        maxH={"600px"}
        borderRadius="0px 10px 10px 10px"
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
      > 
      {chats?(
      <UserChats loggedUser={{...loggedUser}}/>) : (
          <ChatLoading />
        )}
     </Box>
     </Stack>
    </TabPanel>

    <TabPanel
     maxH={'90%'}
    // border={'1px solid blue'}
    >
       <Stack 
          minW={'200px'}
            h={'100%'}
          w={'100%'}
          >
      <Box
        display="flex"
        flexDir="column"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        // backgroundColor={"bgs.accntBx"}
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        minH={"500px"}
        maxH={"600px"}
        w={{ base: "100%" }}
        h="100%"
        borderRadius="0px 10px 10px 10px"
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
      > 
      {chats?(
      <GroupChats loggedUser={loggedUser}/>) : (
          <ChatLoading />
        )}
     </Box>
     </Stack>
    </TabPanel>
  </TabPanels>
</Tabs>
     
    </Box>
  )
}

export default MyChats